<style lang="scss" scoped>
.container {
  .header {
    padding: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 15px;
    margin-left: -8.5px;
    .tag {
      position: static;
      width: 5px;
      height: 16px;
      top: 3px;
      background: #419FFF;
      flex: none;
      order: 0;
      flex-grow: 0;
      margin: 0 10px;
    }
    .title {
      font-size: 16px;
      font-family: Microsoft YaHei UI,serif;
      line-height: 22px;
      color: #303133;
    }
    .info {
      display: flex;
      width: 600px;
      align-items: center;
      justify-content: space-around;
      .detail {
        .detail-title {
          color: #909399;
          font-size: 12px;
        }
        .detail-value {
          color: #303133;
          font-size: 12px;
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
<template>
  <div class="container">
    <div v-if="chartList.length > 0">
      <div v-for="(item, index) in chartList" :key="index">
        <div class="header">
          <div class="tag"></div>
          <div class="title">{{item.pointCodes | getCNNameByCode(that)}}</div>
          <div class="info">
            <div class="detail">
              <span class="detail-title">{{$t('yangbenshu')}}</span>
              <span class="detail-value">{{item.sampleValue > 0 ? (isFinite(item.sampleValue) ? item.sampleValue : '') : ''}}</span>
            </div>
            <div class="detail">
              <span class="detail-title">{{$t('cankaozhi')}}</span>
              <span class="detail-value">{{item.refValue  >= 0 ? (isFinite(item.refValue ) ? item.refValue  : '') : ''}}</span>
            </div>
            <div class="detail">
              <span class="detail-title">{{$t('zuidazhi')}}</span>
              <span class="detail-value">{{item.maxValue > 0 ? (isFinite(item.maxValue) ? item.maxValue : '') : ''}}</span>
            </div>
            <div class="detail">
              <span class="detail-title">{{$t('zuixiaozhi')}}</span>
              <span class="detail-value">{{item.minValue}}</span>
            </div>
            <div class="detail">
              <span class="detail-title">{{$t('zuidapiancha')}}</span>
              <span class="detail-value">{{item.maxDeviation}}</span>
            </div>


            <div class="detail">
              <span class="detail-title">{{$t('pingjunpiancha')}}</span>
              <span class="detail-value">{{item.meanDeviation}}</span>
            </div>
            <div class="detail">
              <span class="detail-title">{{$t('biaozhunpiancha')}}</span>
              <span class="detail-value">{{item.standardDeviation}}</span>
            </div>
          </div>
        </div>
        <div class="chart">
          <div :id="item.id" style="width: 100%;height:400px;"></div>
        </div>
        <div :id="'status_' + item.id" :style="{'height':chartHeight2+'px'}" style="margin-right: 20px;margin-top: 2px;margin-left: 15px"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stability_multiple_chart',
  filters: {
    getCNNameByCode(code, that) {
      let res = that.dict.filter(item => {
        return item.code === code
      })
      if (res.length > 0) {
        const unit = res[0]['unit'];
        return unit ? res[0]['i18n'] + '(' + unit + ')' : res[0]['i18n'];
      } else {
        return code
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    codes: {
      type: Array,
      default: () => {
        return []
      }
    },
    dict: {
      type: Array,
      default: () => {
        return []
      }
    },
    conditions: []
  },
  data() {
    return {
      that: this,
      chartList: [],
      // 设备状态条
      chart2: null,
      options2: null,
      chartHeight2: 100,
      chart2ValueData: [],
      codeMap: {},
      statusColors: {
        "0": "#7DFFBE",
        "3": "#FF809F",
        "1": "#FFD580",
        "-1": "#7582A3",
        "-2": "#7582A3",
      }
    }
  },
  watch: {
    list: {
      handler(n) {
        this.fetchChart()
        if (this.chart2) {
          this.chart2.resize()
        }
      },
      immediate: false,
      deep: true
    }
  },
  mounted() {
    this.fetchChart()
    if (this.chart2) {
      this.chart2.resize()
    }
  },
  methods: {
    // 工艺参数中文映射
    getCNNameByCode(code) {
      let res = this.dict.filter(item => {
        return item.code === code
      })
      if (res.length > 0) {
        const unit = res[0]['unit'];
        return unit ? res[0]['i18n'] + '(' + unit + ')' : res[0]['i18n'];
      } else {
        return code
      }
    },
    /**
     * 时间转换
     * @param time
     * @returns {string}
     */
    timestampToTime(time) {
      const t = new Date(time)
      // 日期格式
      const format = 'Y-m-d h:i:s'
      let year = t.getFullYear()
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1
      let day = t.getDate() + '\n'
      let hours = t.getHours()
      let minutes = t.getMinutes()
      let seconds = t.getSeconds()
      month = month > 9 ? month : `0${month}`
      day = day > 9 ? day : `0${day}`
      hours = hours > 9 ? hours : `0${hours}`
      minutes = minutes > 9 ? minutes : `0${minutes}`
      seconds = seconds > 9 ? seconds : `0${seconds}`
      const hash = {
        'Y': year,
        'm': month,
        'd': day,
        'h': hours,
        'i': minutes,
        's': seconds
      }
      return format.replace(/\w/g, o => {
        return hash[o]
      })
    },
    /**
     * 重置图表
     */
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        // this.screenWidth = document.body.clientWidth
        if (this.chartList.length > 0) {
          for (let i = 0; i < this.chartList.length; i++) {
            if (this.chartList[i]['barChart'] != null) {
              this.chartList[i]['barChart'].resize()
            }
          }
        }
      }, 500)
    },
    /**
     * 渲染图表
     * @returns {boolean}
     */
    fetchChart() {
      this.chartList = []
      if (this.list.length === 0) {
        return false
      }
      const pointCodes = [...this.codes]
      if (pointCodes.length === 0) {
        return false
      }
      for (let i = 0; i < pointCodes.length; i++) {
        this.chartList.push({
          id: 'id' + i, // 索引
          barChart: '', // chart对象实例
          maxValue: 0, // 最大数
          minValue: 0, // 最小数
          middleValue: 0, // 中位数
          sampleValue: 0, // 样本数
          echartData: [], // 图表数据
          pointCodes: pointCodes[i]
        })
      }
      const arr = [...this.list]
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr[i]['points'].length; j++) {
          for (let z = 0; z < this.chartList.length; z++) {
            if (this.chartList[z]['pointCodes'] === arr[i]['points'][j]['code']) {
              this.chartList[z]['echartData'].push({
                ...arr[i]['points'][j],
                time: arr[i]['time']
              })
            }
          }
        }
      }
      this.resize()
      this.http
          .get("/web/process/stability/params/page", {
            params: {
              pageSize: 9999,
              equipmentId: this.equipmentId
            },
          })
          .then((response) => {
            let data = response.data;
            if (data.rows.length > 0) {
                this.codeMap = data.rows.reduce((acc, item) => {
                acc[item.templatePoint.code] = item;
                return acc;
              }, {});
            }
            this.$nextTick(() => {
              for (let i = 0; i < this.chartList.length; i++) {
                const echartData = this.chartList[i]['echartData']

                let refValue = this.codeMap[this.chartList[i]['pointCodes']].refValue
                let tolerance = this.codeMap[this.chartList[i]['pointCodes']].percent * refValue / 100
                let upperLimit = this.codeMap[this.chartList[i]['pointCodes']].upperLimit

                this.chartList[i]['barChart'] = this.echarts.init(document.getElementById(this.chartList[i]['id']))
                this.chartList[i]['sampleValue'] = echartData.length
                this.chartList[i]['maxValue'] = Math.max.apply(Math, echartData.map(o => {
                  return o.value
                })) // 最大值
                this.chartList[i]['minValue'] = Math.min.apply(Math, echartData.map(o => {
                  return o.value
                })) // 最小值

                this.chartList[i]['refValue'] = refValue

                // 平均偏差
                this.chartList[i]['meanDeviation'] = (echartData.reduce((sum, dataPoint) => {
                  return sum + Math.abs(dataPoint.value - refValue);
                }, 0) / echartData.length).toFixed(1);
                // 标准偏差
                const variance = (echartData.reduce((sum, dataPoint) => {
                  return sum + Math.pow(dataPoint.value - refValue, 2);
                }, 0) / echartData.length).toFixed(1);

                this.chartList[i]['standardDeviation'] = Math.sqrt(variance).toFixed(1);

                // 最大偏差
                this.chartList[i]['maxDeviation'] = Math.max(Math.abs(this.chartList[i]['minValue'] - refValue), Math.abs(this.chartList[i]['maxValue'] - refValue)).toFixed(1);


                let maxYAxisValue = Math.max(tolerance, (this.chartList[i]['maxValue'] - refValue));
                let minYAxisValue = Math.min(-tolerance, (this.chartList[i]['minValue'] - refValue));

                let xAxis = echartData.map(item => {
                  return this.timestampToTime(item.time)
                })
                let yAxis = echartData.map(item => {
                  return (item.value - refValue).toFixed(1)
                })
                let option = {
                  tooltip: {
                    trigger: 'axis',
                    formatter: (params) => {
                      const data = params[0]
                      const originalVal = (Number(data.value) + Number(refValue)).toFixed(1);
                      // 检查 unit 属性是否存在
                      const unit = this.chartList[i]['echartData'][0]['unit'] || '';
                      return data.name + '<br />' + '<br/>' +
                          data.marker + '  ' + data.seriesName +
                          ' ' + originalVal + '<br />' +
                          data.marker + '  ' + this.$t('pianchazhi') +'(' + unit +')：' + data.value
                    }
                  },
                  grid: {
                    top: '20',
                    left: '20',
                    right: '40',
                    bottom: '20',
                    containLabel: true
                  },
                  toolbox: {
                    show: true,
                    feature: {}
                  },
                  calculable: true,
                  xAxis: [{
                    type: 'category',
                    boundaryGap: true,
                    data: xAxis,
                    // boundaryGap: [10, 100],
                    axisTick: {
                      alignWithLabel: true,
                    },

                    axisLable: {
                      interval: 0,
                      show: true,
                    }
                  }],
                  yAxis: {
                    type: 'value',
                    axisLine: {
                      show: false
                    },
                    axisTick: {
                      show: true
                    },
                    max: (maxYAxisValue * 1.2).toFixed(1),
                    min: (minYAxisValue * 1.2).toFixed(1)
                  },
                  series: [{
                    name: this.getCNNameByCode(this.chartList[i]['pointCodes']),
                    smooth: true,
                    type: 'line',
                    stack: '总量',
                    data: yAxis,
                    showSymbol: false,
                    color: '#419FFF',
                    lineStyle: {
                      color: '#419FFF',
                    }
                    ,markLine: {
                      data: [
                        {
                          yAxis: refValue, // 自定义值
                          label: { // 不显示基准线名称
                            show: true,
                          },
                          lineStyle: {
                            type: 'dashed', // 基准线样式为虚线
                            color: '#f5e84f',
                          },
                        },
                        {
                          yAxis: -tolerance, // 自定义值
                          label: { // 不显示基准线名称
                            show: true,
                          },
                          lineStyle: {
                            type: 'dashed', // 基准线样式为虚线
                            color: '#f13524',
                          },
                        },
                        {
                          yAxis: tolerance, // 自定义值
                          label: { // 不显示基准线名称
                            show: true,
                          },
                          lineStyle: {
                            type: 'dashed', // 基准线样式为虚线
                            color: '#f13524',
                          },
                        }
                      ]
                    }

                  }]
                };
                // 使用刚指定的配置项和数据显示图表。
                this.chartList[i]['barChart'].setOption(option);
              }
              this.echarts.connect(this.chartList.map(item => {
                return item['barChart']
              }))
            })
          }).catch(error => {
            this.utils.errorMessage(error);
          })

    },


    initChart2() {
      this.option2 = {
        tooltip: {
          show: false,
          trigger: 'axis',
          axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        legend: {
          show: false,
        },
        grid: {
          top: '10',
          left: '0',
          right: '10',
          bottom: '30',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: false,
          min:0,
          max:24,
          minInterval: 1,
          maxInterval: 1,
          axisLabel: {
            show: false,
            formatter: (value, index) => {
              if (this.chart2ValueData) {
                return index.toString();
              }
              return "-"
            }

          }
        },
        yAxis: {
          show: false,
          type: 'category',
        },
        series: this.chart2ValueData
      };
      for (let i = 0; i < this.chartList.length; i++) {
        var chartDom = document.getElementById('status_'+ this.chartList[i]['id']);
        this.chart2 = this.echarts.init(chartDom);
        this.option2 && this.chart2.setOption(this.option2);
      }
    },

  }
}
</script>
